import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './loading-indicator.scss';
import { LogoWord } from '@codametrix/verdigris';
const optValues = {
    text: 'Starting...'
};
const indicator = (props)=>{
    const values = {
        ...optValues,
        ...props
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "loading-indicator qa-loading-indicator",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "loading-indicator-inner upper-loading-container",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "loading-graphic",
                        viewBox: "0 0 100 100",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ _jsx("circle", {
                            cx: "50",
                            cy: "50",
                            r: "45"
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "empty-title h6",
                        children: values.text
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "logo-loading-container loading-indicator-inner",
                children: /*#__PURE__*/ _jsx(LogoWord, {
                    iconClass: "logo-word",
                    titleText: "Codametrix Logo"
                })
            })
        ]
    });
};
export default indicator;
